import { ReadingImageResultType } from '../redux/jobs/jobs.types';

export class InvalidReadingImagePayloadError extends Error {
    constructor(message = 'Invalid reading image payload') {
        super(message);
        this.name = 'InvalidReadingImagePayloadError';
    }
}

export const toReadingImagePayload = (dataUri: string): ReadingImageResultType => {
    const imageMatch = dataUri.trim().match(/^data:(image\/jpeg);base64,(.+)$/);

    if (!imageMatch) {
        throw new InvalidReadingImagePayloadError();
    }

    return {
        encodedImage: imageMatch[2],
        mimeType: imageMatch[1],
    };
};
